module.exports = __webpack_public_path__ + "img/actualCase-5.e5605e59.jpg";